import { ConcreteEncodable } from "./ConcreteEncodable";

import { SystemSettingImplEncoder } from "../../encoder/SystemSettingImplEncoder";

import * as CubiqTS from "../../index";
import { SystemSetting } from "../SystemSetting";

export class SystemSettingImpl extends ConcreteEncodable implements SystemSetting {
  public static enType: string = "com.bcdfx.model.SystemSettingImpl";

  /*FID=1*/
  public settingId: string;
  /*FID=2*/
  public settingValue: string;
  /*FID=3*/
  public description: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SystemSettingImplEncoder.Instance;
    this.setEncodableType(SystemSettingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SystemSettingImpl[" +
      "settingId=" +
      this.settingId +
      "settingValue=" +
      this.settingValue +
      "description=" +
      this.description +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
